var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          route_name: "payment_orders",
          route_grid_path: "/grid",
          order_column: "created_at",
          direction: "desc",
          "show-export": true,
          "export-types": ["csv", "xls"],
          "export-filename": "hubee_payment_orders",
          "fetch-on-mounted": false,
          hide_searchbar: "true",
        },
        scopedSlots: _vm._u([
          {
            key: "filterZone",
            fn: function () {
              return [
                _c("FinancialPeriodFilter", {
                  on: { change: _vm.handleFilterChange },
                  model: {
                    value: _vm.filters,
                    callback: function ($$v) {
                      _vm.filters = $$v
                    },
                    expression: "filters",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "gridThead",
            fn: function () {
              return [
                _c("vs-th", { key: "id", attrs: { "sort-key": "id" } }, [
                  _vm._v("ID Pedido"),
                ]),
                _c(
                  "vs-th",
                  {
                    key: "amount_total",
                    attrs: { "sort-key": "amount_total" },
                  },
                  [_vm._v("Valor Total")]
                ),
                _c("vs-th", { key: "user_name" }, [_vm._v("Nome do Usuário")]),
                _c("vs-th", { key: "user_email" }, [
                  _vm._v("Email do Usuário"),
                ]),
                _c(
                  "vs-th",
                  { key: "status", attrs: { "sort-key": "status" } },
                  [_vm._v("Status")]
                ),
                _c(
                  "vs-th",
                  {
                    key: "payment_type",
                    attrs: { "sort-key": "payment_type" },
                  },
                  [_vm._v("Tipo Pagamento")]
                ),
                _c(
                  "vs-th",
                  { key: "created_at", attrs: { "sort-key": "created_at" } },
                  [_vm._v("Data")]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "gridData",
            fn: function (props) {
              return _vm._l(props.data, function (tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c("vs-td", { key: "id", attrs: { width: "10%" } }, [
                      _c("div", [_vm._v(_vm._s(tr.id))]),
                    ]),
                    _c(
                      "vs-td",
                      { key: "amount_total", attrs: { width: "15%" } },
                      [
                        _c("span", { staticClass: "font-semibold" }, [
                          _vm._v(_vm._s(_vm.formatCurrency(tr.amount_total))),
                        ]),
                      ]
                    ),
                    _c("vs-td", { key: "user_name", attrs: { width: "15%" } }, [
                      _c("div", [_vm._v(_vm._s(tr.user_name || "N/A"))]),
                    ]),
                    _c(
                      "vs-td",
                      { key: "user_email", attrs: { width: "20%" } },
                      [_c("div", [_vm._v(_vm._s(tr.user_email || "N/A"))])]
                    ),
                    _c(
                      "vs-td",
                      { key: "status", attrs: { width: "15%" } },
                      [
                        _c(
                          "vs-chip",
                          {
                            staticClass: "text-base text-center",
                            attrs: { color: _vm.getStatusColor(tr.status) },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.getStatusLabel(tr.status)) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "vs-td",
                      { key: "payment_type", attrs: { width: "20%" } },
                      [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.getPaymentTypeLabel(tr.payment_type))
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "vs-td",
                      { key: "created_at", attrs: { width: "20%" } },
                      [
                        _c("div", [
                          _vm._v(_vm._s(_vm.$utils.format.date(tr.created_at))),
                        ]),
                      ]
                    ),
                    _c(
                      "vs-td",
                      { attrs: { width: "10%" } },
                      [
                        _c("feather-icon", {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top",
                              value: {
                                content: "Detalhamento",
                                delay: { show: 100, hide: 100 },
                              },
                              expression:
                                "{\n              content: 'Detalhamento',\n              delay: { show: 100, hide: 100 }\n            }",
                              modifiers: { top: true },
                            },
                          ],
                          staticClass:
                            "h-5 w-5 mb-1 mr-1 stroke-current text-primary cursor-pointer",
                          attrs: { icon: "EyeIcon" },
                          on: {
                            click: function ($event) {
                              return _vm.viewDetails(tr)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              })
            },
          },
        ]),
      }),
      _c(
        "vs-popup",
        {
          staticClass: "order-details-popup",
          attrs: {
            title:
              "Detalhes do Pedido" +
              (_vm.orderDetails ? " #" + _vm.orderDetails.id : ""),
            active: _vm.showDetails,
          },
          on: {
            "update:active": function ($event) {
              _vm.showDetails = $event
            },
          },
        },
        [
          _vm.orderDetails
            ? _c("div", { staticClass: "order-details" }, [
                _c("div", { staticClass: "mb-6 grid grid-cols-2 gap-6" }, [
                  _vm.orderDetails.user
                    ? _c("div", [
                        _c(
                          "h5",
                          {
                            staticClass:
                              "vs-popup--title mb-1 text-base font-semibold",
                          },
                          [_vm._v(" Cliente ")]
                        ),
                        _c("div", { staticClass: "flex flex-col space-y-2" }, [
                          _c("div", [
                            _c(
                              "span",
                              { staticClass: "text-gray-600 text-sm" },
                              [_vm._v("Nome:")]
                            ),
                            _c("span", { staticClass: "ml-2 font-medium" }, [
                              _vm._v(
                                _vm._s(_vm.orderDetails.user.name || "N/A")
                              ),
                            ]),
                          ]),
                          _c("div", [
                            _c(
                              "span",
                              { staticClass: "text-gray-600 text-sm" },
                              [_vm._v("Email:")]
                            ),
                            _c("span", { staticClass: "ml-2 font-medium" }, [
                              _vm._v(
                                _vm._s(_vm.orderDetails.user.email || "N/A")
                              ),
                            ]),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _c("div", [
                    _c(
                      "h5",
                      {
                        staticClass:
                          "vs-popup--title mb-1 text-base font-semibold",
                      },
                      [_vm._v("Pedido")]
                    ),
                    _c("div", { staticClass: "flex flex-col space-y-2" }, [
                      _c("div", [
                        _c("span", { staticClass: "text-gray-600 text-sm" }, [
                          _vm._v("Data:"),
                        ]),
                        _c("span", { staticClass: "ml-2 font-medium" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$utils.format.date(
                                _vm.orderDetails.created_at
                              )
                            )
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _c("span", { staticClass: "text-gray-600 text-sm" }, [
                          _vm._v("Valor Total:"),
                        ]),
                        _c(
                          "span",
                          {
                            staticClass:
                              "ml-2 font-semibold text-lg text-primary",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.formatCurrency(
                                  _vm.orderDetails.amount_total
                                )
                              )
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", [
                  _c(
                    "h5",
                    {
                      staticClass:
                        "vs-popup--title mb-1 text-base font-semibold",
                    },
                    [_vm._v(" Itens do Pedido ")]
                  ),
                  _vm.orderDetails.items && _vm.orderDetails.items.length > 0
                    ? _c("div", [
                        _c("table", { staticClass: "w-full" }, [
                          _c("thead", [
                            _c("tr", { staticClass: "border-b" }, [
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "text-left py-1 px-2 text-sm font-semibold text-gray-700",
                                },
                                [_vm._v(" Produto ")]
                              ),
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "text-center py-1 px-2 text-sm font-semibold text-gray-700",
                                },
                                [_vm._v(" Qtd ")]
                              ),
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "text-right py-1 px-2 text-sm font-semibold text-gray-700",
                                },
                                [_vm._v(" Valor Unit. ")]
                              ),
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "text-right py-1 px-2 text-sm font-semibold text-gray-700",
                                },
                                [_vm._v(" Subtotal ")]
                              ),
                            ]),
                          ]),
                          _c(
                            "tbody",
                            _vm._l(
                              _vm.orderDetails.items,
                              function (item, index) {
                                return _c(
                                  "tr",
                                  { key: index, staticClass: "border-b" },
                                  [
                                    _c("td", { staticClass: "py-1 px-2" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item.product
                                              ? item.product.name
                                              : "N/A"
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c(
                                      "td",
                                      { staticClass: "py-1 px-2 text-center" },
                                      [_vm._v(_vm._s(item.quantity))]
                                    ),
                                    _c(
                                      "td",
                                      { staticClass: "py-1 px-2 text-right" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatCurrency(item.price)
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      {
                                        staticClass:
                                          "py-1 px-2 text-right font-semibold",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatCurrency(
                                                item.amount_total
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                          _c("tfoot", [
                            _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass:
                                    "py-2 px-2 text-right font-semibold",
                                  attrs: { colspan: "3" },
                                },
                                [_vm._v(" Total: ")]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass:
                                    "py-2 px-2 text-right font-bold text-primary text-base",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatCurrency(
                                          _vm.orderDetails.amount_total
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                      ])
                    : _c(
                        "div",
                        { staticClass: "text-center py-4 text-gray-500" },
                        [_vm._v(" Nenhum item encontrado ")]
                      ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }